import "./style.scss";
import { FC } from "react";
import backForDocMalta from "@/src/assets/admissionOfficePage/back-for-doc-malta.webp";
import backForDocPoland from "@/src/assets/admissionOfficePage/back-for-doc-poland.webp";
import backForDocUkraine from "@/src/assets/admissionOfficePage/back-for-doc-ukraine.webp";
import { AOPMaltaPaymentConfirmationData } from "@/src/types/admissionOffice";
import type { AdmissionOfficeCountry } from "../../../admissionOfficeCountry";

const BACKGROUNDS: Record<AdmissionOfficeCountry, string> = {
  malta: backForDocMalta,
  poland: backForDocPoland,
  ukraine: backForDocUkraine,
};

interface AOPPrevProps {
  country: AdmissionOfficeCountry;
  bodyForPrev: AOPMaltaPaymentConfirmationData;
  isPrevReady: boolean;
}

const AOPPrev: FC<AOPPrevProps> = ({ country, bodyForPrev, isPrevReady }) => {
  const actualBg = BACKGROUNDS[country];
  const dateLine = bodyForPrev.currentDate ? bodyForPrev.currentDate : "-";
  const isPlUa = country === "poland" || country === "ukraine";

  return (
    <div className="admission-office-prev-wrapper">
      <div className={`admission-office-prev ${country} payment`}>
        <img className="admission-office-prev-background" src={actualBg} alt="" />
        <div className="admission-office-prev-section title">
          {isPlUa ? <p>Payment confirmation letter</p> : "Payment confirmation letter"}
        </div>
        <div className="admission-office-prev-section number-and-date">
          {isPlUa ? (
            <>
              <span>Date: {dateLine}</span>
              <span>№ -</span>
            </>
          ) : (
            <>
              <span>№ -</span>
              <span>Date: {dateLine}</span>
            </>
          )}
        </div>
        {bodyForPrev.payment_header ? (
          <div className="admission-office-prev-section body-content header">
            {bodyForPrev.payment_header?.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
        <div className={`admission-office-prev-section info ${isPrevReady ? "preview" : ""}`}>
          <p>Full Name: {bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
          <p>Data of Birth: {bodyForPrev.dateOfBirth ? bodyForPrev.dateOfBirth : ""}</p>
          <p>Nationality: {bodyForPrev.nationality ? bodyForPrev.nationality : ""}</p>
          <p>Course: {bodyForPrev.course ? bodyForPrev.course : ""}</p>
          <p>Medium of Instruction: {bodyForPrev.mediumOfInstruction ? bodyForPrev.mediumOfInstruction : ""}</p>
          <p>Duration: {bodyForPrev.duration ? bodyForPrev.duration : ""}</p>
        </div>
        <div className="admission-office-prev-section signature">
          <p>Head of Foreign Students department</p>
          <p>Fedorova Anzhelika</p>
          <p>International European University</p>
        </div>
        {bodyForPrev.payment_footer ? (
          <div className="admission-office-prev-section body-content footer">
            {bodyForPrev.payment_footer?.map((item, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AOPPrev;
